import {CSSProperties, FC} from 'react';


export interface IIconLengthProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconLength: FC<IIconLengthProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M16.55 10h-.208l-.812-1.872c-.297-.68-1.012-1.127-1.807-1.128h-3.9c-.932-.002-1.735.603-1.918 1.446L7.567 10H7.45c-1.077 0-1.95.806-1.95 1.8v1.8c0 .16.068.312.19.424a.679.679 0 0 0 .46.176h.65c0 .994.873 1.8 1.95 1.8s1.95-.806 1.95-1.8h2.6c0 .994.873 1.8 1.95 1.8s1.95-.806 1.95-1.8h.65c.359 0 .65-.269.65-.6v-1.8c0-.994-.873-1.8-1.95-1.8Zm-3.9-1.8h1.072c.264.002.5.152.598.378L14.938 10H12.65V8.2Zm-3.471.48c.063-.284.336-.486.65-.48h1.521V10H8.893l.286-1.32ZM8.75 14.8c-.359 0-.65-.269-.65-.6 0-.331.291-.6.65-.6.359 0 .65.269.65.6 0 .331-.291.6-.65.6Zm6.5 0c-.359 0-.65-.269-.65-.6 0-.331.291-.6.65-.6.359 0 .65.269.65.6 0 .331-.291.6-.65.6ZM17.2 13h-.507a2.027 2.027 0 0 0-1.443-.59c-.55 0-1.073.215-1.443.59h-3.614a2.027 2.027 0 0 0-1.443-.59c-.55 0-1.073.215-1.443.59H6.8v-1.2c0-.331.291-.6.65-.6h9.1c.359 0 .65.269.65.6V13ZM22 13.799l1.5-1.299-1.5-1.299V12h-2v1h2v.799ZM2.5 11.201 1 12.5l1.5 1.299V13h2v-1h-2v-.799Z" clipRule="evenodd" />
        </svg>
    );
};
